import React from "react";

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import HighlightsBodyField from "../components/highlights/fields/HighlightsBodyField";

import _ from 'lodash';

export default class HighlightsContainer extends React.Component {

    highlightModules = [
		{ label: '1ª Fase - Videoaulas', value: 'firstPhaseVideoClass' },
		{ label: '1ª Fase - SmartCoach', value: 'firstPhaseSmartCoach' },
		{ label: '1ª Fase - Materiais', value: 'firstPhaseMaterials' },
		{ label: '1ª Fase - Vade Mecum', value: 'firstPhaseVadeMecum' },
		{ label: '1ª Fase - Questões Comentadas', value: 'firstPhaseCommentedQuestions' },
		// { label: '2ª Fase - Videoaulas', value: 'secondPhaseVideoClass' },
		// { label: '2ª Fase - Tips', value: 'secondPhaseTips' },
		// { label: '2ª Fase - Materiais', value: 'secondPhaseMaterials' },
		// { label: '2ª Fase - Vade Mecum', value: 'secondPhaseVadeMecum' },
		// { label: '2ª Fase - Questões Comentadas', value: 'secondPhaseCommentedQuestions' },
	];

    constructor(props) {
        super(props);

        this.state = {
            application: '3ftlLhJYXpVqmP5joDcbVW',
			message: '',
			messageError: '',
            selectedModule: '',
			requesting: false,
			errorMsg: '',
			selectedHighlightModuleError: '',
			openConfirmationDialog: false,
        };

		this.showConfirmationDialog = this.showConfirmationDialog.bind(this);
		this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this);
		this.clearForm = this.clearForm.bind(this);
		this.onChangeField = this.onChangeField.bind(this);
		this.validate = this.validate.bind(this);
		this.submit = this.submit.bind(this);
    }

	showConfirmationDialog() {
		this.setState({ openConfirmationDialog: true });
	}

	closeConfirmationDialog() {
		this.setState({ openConfirmationDialog: false });
	}

	clearForm() {
		this.setState({
			message: '',
			selectedHighlightModule: '',
		});
	}

	onChangeField(field, value) {
		this.setState({
			[field]: value
		});
	}

	validate() {
		const message = this.state.message.trim();
		const selectedHighlightModule = this.state.selectedHighlightModule;

		this.setState({
			messageError: '',
			errorMsg: '',
		});

		const errors = {};

		if (!message) {
			errors.messageError = 'A mensagem é obrigatória';
		} else if (message.length > 235) {
			errors.messageError = 'A mensagem deve ter no máximo 235 caracteres';
		}

		if (!selectedHighlightModule) {
			errors.selectedHighlightModuleError = 'O módulo é obrigatório';
		}

		if (Object.keys(errors).length > 0) {
			this.setState(errors);
		} else {
			this.showConfirmationDialog();
		}
	}

	submit() {
		this.closeConfirmationDialog();

		const { state } = this;

		this.setState({
			requesting: true,
		});

		const { application, message, selectedHighlightModule } = state;

		this.props.fetchApi('post', '/notifications', {
			applicationId: application,
			title: 'Novidade',
			message,
			highlight: {
				module: selectedHighlightModule,
			},
			mauticSegments: null,
			expirationHours: 72,
			notSendPush: true,
		}).then((response) => {

			this.props.showSnackbar('Destaque criado com sucesso!');
			this.setState({ requesting: false });
			this.clearForm();
		}).catch((error) => {
			this.setState({
				requesting: false,
				errorMsg: _.get(error, 'message.response.data.errors[0].detail', 'Ocorreu um erro ao criar o destaque'),
			});
		});
	}

    render() {
        const {
            application,
            message,
			messageError,
			requesting,
			errorMsg,
			openConfirmationDialog,
        } = this.state;

		const confirmationDialogActions = [
			<Button
				key="cancel"
				variant="contained"
				onClick={this.closeConfirmationDialog}
			>
				Não
			</Button>,
			<Button
				key="confirm"
				variant="contained"
				color="primary"
				onClick={this.submit}
			>
				Sim
			</Button>
		];

        return (
			<div>
				<Card style={{ padding: '1rem' }}>
					<CardHeader
						title="Enviar Destaque"
					/>
					<form>
						<InputLabel shrink >
							Aplicação
						</InputLabel>
						<Select
							label="Aplicação"
							value={application}
							onChange={() => null}
						>
							<MenuItem value="3ftlLhJYXpVqmP5joDcbVW">
								OAB de Bolso
							</MenuItem>
						</Select>
						<br />
						<HighlightsBodyField
							messageError={messageError}
							message={message}
							onChangeField={this.onChangeField}
						/>
						<br />
						<br />
							<React.Fragment>
								<InputLabel shrink >
									Módulo
								</InputLabel>
								<Select
									value={this.state.selectedHighlightModule}
									onChange={(event) => this.onChangeField('selectedHighlightModule', event.target.value)}
									displayEmpty
								>
									<MenuItem value=""><em>Selecione um módulo</em></MenuItem>
									{this.highlightModules.map((module, idx) => (
										<MenuItem key={idx} value={module.value}>
											{module.label}
										</MenuItem>
									))}
								</Select>
								{this.state.selectedHighlightModuleError && (
									<p style={{ color: 'red' }}>{this.state.selectedHighlightModuleError}</p>
								)}
							</React.Fragment>
						<br />
						<Button variant="contained" color="primary" onClick={this.validate}>Enviar</Button>
						{requesting && <CircularProgress style={{ marginLeft: '1rem' }} />}
						{errorMsg && <p style={{ color: 'red' }}>{errorMsg}</p>}
					</form>
				</Card>
				<Dialog
					open={openConfirmationDialog}
				>
					<DialogContent>
						<DialogContentText>
							Deseja enviar a notificação?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						{confirmationDialogActions}
					</DialogActions>
				</Dialog>
			</div>
		);
    }
}


// WEBPACK FOOTER //
// ./src/containers/Highlights.js